import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFloatingMenuState } from '../../types/interfaces/states';
import { RootState } from '../store';

const initialState: IFloatingMenuState = {
  asset: null,
  node: null,
  open: false,
  position: {
    x: 0,
    y: 0,
  },
  route: -1,
  reload: 0,
};

const floatingMenuSlice = createSlice({
  name: 'floatingMenu',
  initialState,
  reducers: {
    close: (state) => {
      state.asset = null;
      state.open = false;
      state.position = {
        x: 0,
        y: 0,
      };
      state.reload = 0;
      state.route = -1;
    },
    open: (state, action: PayloadAction<IFloatingMenuState>) => {
      state.asset = action.payload.asset;
      state.node = action.payload.node;
      state.open = true;
      state.route = action.payload.route;
      const position = action.payload.position;
      state.position = {
        x: position.x,
        y: position.y,
      };
    },
    reload(state) {
      state.reload = (state.reload || 0) + 1;
    },
  },
});

const { actions, reducer: floatingMenuReducer } = floatingMenuSlice;
export const { close, open, reload } = actions;
export const floatingMenuSelector = (state: RootState) => state.floatingMenu;
export default floatingMenuReducer;
